(function () {
  if (window.m8ToolsTrackingBound) return;
  window.m8ToolsTrackingBound = true;
  document.documentElement.setAttribute('data-m8-tools-tracking', 'ready');

  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;

    var link = event.target.closest('[data-m8-tools-link]');
    if (!link) return;
    link.setAttribute('data-m8-tools-click-tracked', 'true');

    var parameters = {
      placement: link.getAttribute('data-m8-tools-placement'),
      destination: link.getAttribute('data-m8-tools-destination')
    };

    if (typeof window.gtag === 'function') {
      window.gtag('event', 'm8_tools_click', parameters);
    } else {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'm8_tools_click',
        placement: parameters.placement,
        destination: parameters.destination
      });
    }
  });
})();
